import client from '@/services/client'

import type { AxiosResponse } from 'axios'

export interface IFlowLabel {
  uuid: string
  flowUuid: string
  code: string
  index: number
  label: string
  defaultValue: string | null
  isVisible: boolean
  createdAt: string | null
  updatedAt: string | null
}

export interface ILabelCreate {
  flowUuid: string
  code: string
  label: string
  defaultValue: string | null
  isVisible: boolean
}

export type ILabelUpdate = Omit<ILabelCreate, 'flowUuid'>

const getAll = async (
  flowUuid: string
): Promise<AxiosResponse<IFlowLabel[]>> => {
  return await client.get<IFlowLabel[]>(`flows/${flowUuid}/labels`)
}

/**
 * Update indexes of labels for flow, order of uuids matters
 * @param {string} flowUuid
 * @param {Array<string>} labelsUuids
 */
const updateIndexes = async (
  flowUuid: string,
  labelsUuids: string[]
): Promise<AxiosResponse<IFlowLabel[]>> => {
  return await client.put<IFlowLabel[]>(`flows/${flowUuid}/label-indexes`, {
    labelUuids: labelsUuids,
  })
}

const create = async (
  label: ILabelCreate
): Promise<AxiosResponse<IFlowLabel>> => {
  return await client.post<IFlowLabel>(`flows/labels`, label)
}

const update = async (
  labelUuid: string,
  label: ILabelUpdate
): Promise<AxiosResponse<IFlowLabel>> => {
  return await client.patch<IFlowLabel>(`flows/labels/${labelUuid}`, label)
}

const destroy = async (labelUuid: string): Promise<AxiosResponse<void>> => {
  return await client.delete<void>(`flows/labels/${labelUuid}`)
}

export const FlowLabels = {
  getAll,
  updateIndexes,
  create,
  update,
  destroy,
}
